import pageNotFoundController from './error/pageNotFound.controller';

app.config(config);

config.$inject = [
  '$routeProvider',
  'moduleLoadingProvider'
];
function config(
  $routeProvider,
  moduleLoadingProvider,
) {
  // Routes (only) for not logged-in users
  // $routeProvider.when('/landing', {
  //   templateUrl: require('./landing/landing.html')
  // });
  //
  // $routeProvider.when('/landing/landsberg', {
  //   templateUrl: require('./landing/landsberg.html'),
  //   controller: 'landsbergController'
  // });
  // End of routes for not logged-in users

  $routeProvider.when('/', {
    redirectTo: '/dashboard'
  });

  $routeProvider.when('/calendar', {
    templateUrl: require('./calendar/calendar.html'),
    controller: 'calendarController',
    resolve: {
      modules: moduleLoadingProvider.resolverLoadLazy(['meteoblue'])[0],
      section: () => 'calendar'
    }
  });

  $routeProvider.when('/admin/index', {
    templateUrl: require('./admin/admin.html'),
    resolve: {
      section: () => 'admin'
    }
  });

  $routeProvider.when('/admin/companySettings', {
    templateUrl: require('./admin/settings/company/companySettings.html'),
    controller: 'companySettingsController',
    resolve: {
      modules: moduleLoadingProvider.resolverLoadLazy(['shop'])[0],
      section: () => 'admin'
    }
  });

  $routeProvider.when('/admin/companySettings/external/plant', {
    templateUrl: require('./admin/settings/external/plant/settingsPlant.html'),
    controller: 'settingsPlantController',
    resolve: {
      modules: moduleLoadingProvider.resolverLoadAll()[0],
      section: () => 'farm'
    }
  });

  $routeProvider.when('/admin/userSettings', {
    templateUrl: require('./admin/settings/user/userSettings.html'),
    resolve: {
      section: () => 'admin'
    }
  });

  // Shop configures it's routes itself, see shop web bundle
  // Shop route: /shop

  // TODO: Remove: template for member route does not exist anymore
  //app.register.routeController('/admin/member', 'admin', 'admin/member');

  // TODO: Remove: template for permissions does not exist anymore
  //app.register.routeController('/admin/permissions', 'permissions', 'admin/permissions');

  // CFNPOC-48729
  // $routeProvider.when('/admin/ticket', {
  //   templateUrl: require('./admin/ticket/ticket.html'),
  //   controller: 'ticketController',
  //   resolve: {
  //     controllerData: [
  //       'ticketControllerDataResolver',
  //       (ticketControllerDataResolver) => ticketControllerDataResolver()
  //     ],
  //     section: () => 'admin'
  //   }
  // });

  $routeProvider.when('/analyse', {
    redirectTo: '/crop'
  });

  $routeProvider.when('/analyse/stockReport', {
    templateUrl: require('./analyse/stockReport.html'),
    controller: 'stockReportController',
    resolve: {
      section: () => 'farm'
    }
  });
  app.addRouteRight('/analyse/stockReport', 'Company:FUNCTIONAL_ANALYSIS');

  $routeProvider.when('/error/pageNotFound', {
    templateUrl: require('./error/pageNotFound.html'),
    controller: pageNotFoundController,
    controllerAs: 'controller',
  });

  $routeProvider.when('/analyse/cropoverview/:cropoverviewyear', {
    templateUrl: require('./planning/cropPlanning/cropPlanningOperation.html'),
    controller: 'cropPlanningOperationController',
    resolve: {
      controllerData: [
        'CropPlanningDataResolver',
        (CropPlanningDataResolver) => CropPlanningDataResolver()
      ],
      section: () => 'crop'
    }
  });

  $routeProvider.when('/planning/index', {
    redirectTo: '/crop'
  });

  // Fruchtfolgeplanung
  $routeProvider.when('/planning/cropsequenceplanning', {
    templateUrl: require('./planning/cropSequencePlanning/cropSequencePlanning.html'),
    controller: 'cropSequencePlanningController',
    resolve: {
      section: () => 'crop'
    }
  });

  $routeProvider.when('/planning/seedplanning', {
    templateUrl: require('./planning/seedPlanning/seedPlanning.html'),
    controller: 'seedPlanningController',
    resolve: {
      controllerData: [
        'seedPlanningDataResolver',
        (seedPlanningDataResolver) => seedPlanningDataResolver()
      ],
      section: () => 'crop'
    }
  });

  $routeProvider.when('/analyse/cropoverview', {
    templateUrl: require('./analyse/cropOverview.html'),
    controller: 'cropOverviewController',
    resolve: {
      controllerData: [
        'cropOverviewControllerResolver',
        (cropOverviewControllerResolver) => cropOverviewControllerResolver()
      ],
      section: () => 'crop'
    }
  });

  $routeProvider.when('/ngX', {
    template: ''
  });

  $routeProvider.otherwise({
    templateUrl: require('./error/pageNotFound.html'),
    controller: pageNotFoundController,
    controllerAs: 'controller',
    resolve: moduleLoadingProvider.resolverLoadLazyByRoute()
  });

  $routeProvider.when('/dashboard', {
    templateUrl: require('./dashboard/dashboard.html'),
    controller: 'dashboardController365',
    resolve: {
      modules: moduleLoadingProvider.resolverLoadLazy([
        'platform',
        'news',
        'dairynet.herdmanagement'
      ])[0],
      section: () => 'dashboard'
    },
  });

  $routeProvider.when('/core/index', {
    redirectTo: '/farm'
  });

  $routeProvider.when('/farm', {
    templateUrl: require('./menu/farm.html'),
    controller: 'farmController',
    resolve: {
      section: () => 'farm'
    },
  });

  $routeProvider.when('/crop', {
    templateUrl: require('./menu/crop.html'),
    controller: 'cropController',
    resolve: {
      section: () => 'crop'
    }
  });

  $routeProvider.when('/cattle', {
    templateUrl: require('./menu/cattle.html'),
    controller: 'cattleController',
    resolve: {
      modules: moduleLoadingProvider.resolverLoadLazy([
        'dairynet.presentation',
        'dairynet.herdmanagement'
      ])[0],
      section: () => 'cattle'
    }
  });

  $routeProvider.when('/livestock', {
    templateUrl: require('./menu/livestock.html'),
    controller: 'livestockController',
    resolve: {
      section: () => 'livestock'
    }
  });

  $routeProvider.when('/genericFarmMap/:plugin?', {
    templateUrl: require('./genericFarmMap/genericFarmMap.html'),
    controller: 'genericFarmMapController',
    resolve: {
      modules: moduleLoadingProvider.resolverLoadLazy([
        'precisionfarming',
        'telematics',
        'routeplanning'
      ])[0],
      section: () => 'map'
    }
  });

  $routeProvider.when('/booking', {
    redirectTo: '/crop'
  });

  $routeProvider.when('/booking/stockyard/list', {
    templateUrl: require('./booking/stockyardList.html'),
    controller: 'stockyardListController',
    resolve: {
      section: () => 'farm'
    }
  });

  $routeProvider.when('/booking/stockyard/:id?', {
    templateUrl: require('./booking/stockyardMask.html'),
    controller: 'stockyardMaskController',
    resolve: {
      section: () => 'farm'
    }
  });

  $routeProvider.when('/booking/field/list', {
    redirectTo: '/reporting/bookingList',
    resolve: {
      section: () => 'crop'
    }
  });

  $routeProvider.when('/booking/field/listOld', {
    templateUrl: require('./booking/bookingList.html'),
    controller: 'bookingListController',
    resolve: {
      section: () => 'crop'
    }
  });

  $routeProvider.when('/booking/field/:id?', {
    templateUrl: require('./booking/bookingMask.html'),
    controller: 'bookingMaskController',
    resolve: {
      sprayweather: moduleLoadingProvider.resolverLoadLazy(['sprayweather'])[0],
      bookingMaskDataResolver: [
        'bookingMaskDataResolver',
        (bookingMaskDataResolver) => bookingMaskDataResolver()
      ],
      section: () => 'crop'
    }
  });

  $routeProvider.when('/booking/activity/:id?', {
    templateUrl: require('./booking/bookingMask.html'),
    controller: 'bookingMaskController',
    resolve: {
      section: () => 'crop'
    }
  });

  $routeProvider.when('/register', {
    redirectTo: () => {
      window.location = `/365FarmNet/dist/login.html#/registration`;
    }
  });

  loadFarmNetCoreRoutes();

  function loadFarmNetCoreRoutes() {
    var isAppPage = app.isAppPage();
    if (!isAppPage) {
      return;
    }

    $routeProvider.when('/core/field/:id?', {
      templateUrl: require('./core/assets/fieldCore.html'),
      controller: 'fieldCoreController',
      resolve: {
        fieldService: moduleLoadingProvider.resolverLoadLazy(['fields'])[0],
        fieldCoreDataResolver: [
          'fieldCoreDataResolver',
          (fieldCoreDataResolver) => fieldCoreDataResolver()
        ],
        section: () => 'crop'
      }
    });
    modules.registerEntity('field', 'FarmNetCore');
    app.addRouteRight('/core/field/', 'Field:UPDATE');
    app.addRouteRight('/core/field/:id', 'Field:UPDATE');
    app.registerBacklinkRoute('field', '/core/field'); // register backlink of entity. this allows to find the correct backlink in goBackToCore

    $routeProvider.when('/core/fieldGroup/:id?', {
      templateUrl: require('./core/assets/fieldGroupCore.html'),
      controller: 'fieldGroupCoreController',
      resolve: {
        fieldGroupCoreDataResolver: [
          'fieldGroupCoreDataResolver',
          (fieldGroupCoreDataResolver) => fieldGroupCoreDataResolver()
        ],
        section: () => 'crop'
      }
    });
    modules.registerEntity('fieldGroup', 'FarmNetCore');
    app.addRouteRight('/core/fieldGroup/', 'FieldGroup:UPDATE');
    app.addRouteRight('/core/fieldGroup/:id', 'FieldGroup:UPDATE');
    app.registerBacklinkRoute('fieldGroup', '/core/fieldGroup');

    $routeProvider.when('/core/stockyard/:id?', {
      templateUrl: require('./core/assets/stockyardCore.html'),
      controller: 'stockyardCoreController',
      resolve: {
        stockyardCoreDataResolver: [
          'stockyardCoreDataResolver',
          (stockyardCoreDataResolver) => stockyardCoreDataResolver()
        ],
        section: () => 'farm'
      }
    });
    modules.registerEntity('stockyard', 'FarmNetCore');
    app.addRouteRight('/core/stockyard/', 'Stockyard:READ');
    app.addRouteRight('/core/stockyard/:id', 'Stockyard:READ');
    app.registerBacklinkRoute('stockyard', '/core/stockyard');

    $routeProvider.when('/core/farm/:id?', {
      redirectTo: '/coredata-service/farms',
    });
    modules.registerEntity('farm', 'FarmNetCore');
    app.addRouteRight('/core/farm/', 'Farm:UPDATE');
    app.addRouteRight('/core/farm/:id', 'Farm:UPDATE');
    app.addRouteRight('/coredata-service/farms', 'Farm:UPDATE');
    app.addRouteRight('/coredata-service/farms/detail/:id', 'Farm:UPDATE');
    app.registerBacklinkRoute('farm', '/core/farm');

    $routeProvider.when('/core/machine/:id?', {
      redirectTo: '/coredata-service/machines'
    });
    modules.registerEntity('machine', 'FarmNetCore');
    app.addRouteRight('/core/machine/', 'Machine:UPDATE');
    app.addRouteRight('/core/machine/:id', 'Machine:UPDATE');
    app.addRouteRight('/coredata-service/machines', 'Machine:UPDATE');
    app.addRouteRight('/coredata-service/machines/detail/:id', 'Machine:UPDATE');
    app.registerBacklinkRoute('machine', '/core/machine');

    $routeProvider.when('/core/v2/seed', {
      /*templateUrl: require('./core/resources/machineCore.html'),
      controller: 'machineCoreController',
      resolve: {
        telematics: moduleLoadingProvider.resolverLoadLazy(['telematics'])[0],
        machineCoreDataResolver: [
          'machineCoreDataResolver',
          function(machineCoreDataResolver) {
            return machineCoreDataResolver();
          }
        ]
      }*/
      redirectTo: '/coredata-service/machines'
    });
    modules.registerEntity('machine', 'FarmNetCore');
    app.addRouteRight('/core/machine/', 'Machine:UPDATE');
    app.addRouteRight('/core/machine/:id', 'Machine:UPDATE');
    app.registerBacklinkRoute('machine', '/core/machine');

    $routeProvider.when('/core/person/:id?', {
      redirectTo: '/coredata-service/persons'
    });

    modules.registerEntity('person', 'FarmNetCore');
    app.addRouteRight('/core/person/', 'Person:UPDATE');
    app.addRouteRight('/core/person/:id', 'Person:UPDATE');
    app.addRouteRight('/coredata-service/persons', 'Person:UPDATE');
    app.addRouteRight('/coredata-service/persons/detail/:id', 'Person:UPDATE');
    app.registerBacklinkRoute('person', '/core/person');

    // Pricing service
    modules.registerEntity('price', 'FarmNetCore');
    $routeProvider.when('/pricing/core/index', {redirectTo: '/pricing-service/prices'});
    app.addRouteRight('/pricing-service/prices', 'Farm:UPDATE');
    app.addRouteRight('/pricing-service/prices/:cat', 'Farm:UPDATE');
    app.addRouteRight('/pricing-service/prices/:cat/:id', 'Farm:UPDATE');


    $routeProvider.when('/core/personGroup/:id?', {
      templateUrl: require('./core/resources/personGroupCore.html'),
      controller: 'personGroupCoreController',
      resolve: {
        personGroupCoreDataResolver: [
          'personGroupCoreDataResolver',
          (personGroupCoreDataResolver) => personGroupCoreDataResolver()
        ],
        section: () => 'farm'
      }
    });
    modules.registerEntity('personGroup', 'FarmNetCore');
    app.addRouteRight('/core/personGroup/', 'PersonGroup:UPDATE');
    app.addRouteRight('/core/personGroup/:id', 'PersonGroup:UPDATE');
    app.registerBacklinkRoute('personGroup', '/core/personGroup');

    $routeProvider.when('/core/fertilizer/:id?', {
      templateUrl: require('./core/supplies/fertilizerCore.html'),
      controller: 'fertilizerCoreController',
      resolve: {
        fertilizerCoreDataResolver: [
          'fertilizerCoreDataResolver',
          (fertilizerCoreDataResolver) => fertilizerCoreDataResolver()
        ],
        section: () => 'crop',
      }
    });
    modules.registerEntity('fertilizer', 'FarmNetCore');
    app.addRouteRight('/core/fertilizer/', 'Fertilizer:UPDATE');
    app.addRouteRight('/core/fertilizer/:id', 'Fertilizer:UPDATE');
    app.registerBacklinkRoute('fertilizer', '/core/fertilizer');

    $routeProvider.when('/core/plantProtectant/:id?', {
      templateUrl: require('./core/supplies/plantProtectantCore.html'),
      controller: 'plantProtectantCoreController',
      resolve: {
        plantProtectantCoreDataResolver: [
          'plantProtectantCoreDataResolver',
          (plantProtectantCoreDataResolver) => plantProtectantCoreDataResolver()
        ],
        section: () => 'crop'
      }
    });
    modules.registerEntity('plantProtectant', 'FarmNetCore');
    app.addRouteRight('/core/plantProtectant/', 'PlantProtectant:UPDATE');
    app.addRouteRight('/core/plantProtectant/:id', 'PlantProtectant:UPDATE');
    app.registerBacklinkRoute('plantProtectant', '/core/plantProtectant');

    $routeProvider.when('/core/seed/:id?', {
      templateUrl: require('./core/supplies/seedCore.html'),
      controller: 'seedCoreController',
      resolve: {
        seedCoreDataResolver: [
          'seedCoreDataResolver',
          (seedCoreDataResolver) =>  seedCoreDataResolver()
        ],
        section: () => 'crop'
      }
    });
    modules.registerEntity('seed', 'FarmNetCore');
    app.addRouteRight('/core/seed/', 'Seed:UPDATE');
    app.addRouteRight('/core/seed/:id', 'Seed:UPDATE');
    app.registerBacklinkRoute('seed', '/core/seed');

    $routeProvider.when('/core/cropSequence/:id?', {
      templateUrl: require('./core/supplies/cropSequenceCore.html'),
      controller: 'cropSequenceCoreController',
      resolve: {
        cropSequenceCoreDataResolver: [
          'cropSequenceCoreDataResolver',
          (cropSequenceCoreDataResolver) => cropSequenceCoreDataResolver()
        ],
        section: () => 'crop'
      }
    });
    modules.registerEntity('cropSequence', 'FarmNetCore');
    app.addRouteRight('/core/cropSequence/', 'CropSequence:UPDATE');
    app.addRouteRight('/core/cropSequence/:id', 'CropSequence:UPDATE');
    app.registerBacklinkRoute('cropSequence', '/core/cropSequence');
  }
}

/* allow only certain pages for not looged in users
  * redirecting needs to be done here for the most part!*/

app.run(run);

run.$inject = [
  '$rootScope',
  '$route',
  '$location',
  'DemoAccountService',
  'navigationService',
  'ng1NgXUrlHandlingStrategy'
];
function run(
  $rootScope,
  $route,
  $location,
  DemoAccountService,
  navigationService,
  ng1NgXUrlHandlingStrategy
) {
  init();

  function init() {
    initEventHandlers();
  }

  function initEventHandlers() {
    $rootScope.$on('$routeChangeSuccess', (event, newUrl) => {
      const isAnAngular2Route = ng1NgXUrlHandlingStrategy.shouldProcessUrl(
        $location.url()
      );
      if (!isAnAngular2Route) {
        var url = newUrl.originalPath || '';
        navigationService.setSectionFromRouteUrl(url);
      }
      disableLoadingVars();

      setPageResponsiveness($location.url());
    });

    $rootScope.$on('$routeChangeError', function(
      event,
      newUrl,
      oldUrl,
      rejection
    ) {
      app.stopPerfTimer('routeChange');
      disableLoadingVars();
      app.finishLoading();
      checkAndDisplayDemoAccountAlert(oldUrl, rejection);
      console.log('route change error');
    });

    $rootScope.$on('$routeChangeStart', function(event, newUrl) {
      const url = location.hash.toString().replace(/#/g, '') || '';
      if ($rootScope.window) {
        $rootScope.window.loading = true;
      }
      $rootScope.templateUrl = url;
      if (
        $rootScope.credentials.loggedIn &&
        $location.search().debug &&
        app.credentials &&
        app.credentials.cfn365site === 'devpack'
      ) {
        $rootScope.debug = $location.search().debug;
      }
    });
  }

  /*
   *  ---- private functions ----
   */
  function setPageResponsiveness(url) {
    /**
     * Define routes that are "full responsive", i.e. span the full window width
     */
    const responsiveRoutes = [
      '/dashboard',
      '/landing/landsberg',
      '/farm',
      '/crop',
      '/livestock',
      '/cattle',
      '/prototype/machine/',
      '/iso-service/',
      '/agrocom-service/',
      '/supply-service/',
      '/coredata-service/machines',
      '/coredata-service/farms',
      '/coredata-service/persons',
      '/pricing-service/',
      '/components',
      '/connect',
      '/guidanceline-service',
      '/master-data-inbox',
      '/mapcenter-service',
      '/fertilizer-planning-service'
    ];

    const route = responsiveRoutes.find(responsiveRoute =>
      url.startsWith(responsiveRoute)
    );
    $rootScope.currentRouteIsFullResponsive = route !== undefined;
  }

  function checkAndDisplayDemoAccountAlert(last, rejection) {
    if (rejection === 'demo-account') {
      // Currently this works only if the route has no parameters!
      $location.path(last ? last.originalPath : '/dashboard');
      DemoAccountService.displayDemoAccountAlert();
    }
  }

  function disableLoadingVars() {
    if ($rootScope.window) {
      $rootScope.window.displayRight = false;
      $rootScope.window.loading = false;
    }
  }
}
